<template>
  <div style="background: white">
    <navigation/>
    &nbsp;
    <client-index/>
  </div>
</template>

<script>
import navigation from './navigation'
import clinetIndex from './clientIndex'

export default {
  name: 'index',
  components: {
    'navigation': navigation,
    'client-index': clinetIndex,
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/index.vue